import React from 'react';
import PropTypes from 'prop-types';
import RadioButton from './RadioButton';
import './styles.scss';

const RadioButtons = ({ buttons, onChange = () => null, value }) => (
    <div className="custom-radio-btn">
        {buttons.map((btn) => {
            const selected = btn.value === value;
            return <RadioButton key={btn.value} {...btn} selected={selected} onClick={onChange} />;
        })}
    </div>
);

RadioButtons.propTypes = {
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
            label: PropTypes.string,
        }),
    ).isRequired,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default RadioButtons;
